import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import React from 'react'
import styled from 'styled-components'

const resource = createResource({
  id: {
    title: 'Persyaratan nasabah Kredit Pintar',
    subTitle:
      'Untuk mengajukan pinjaman tunai cepat cair di Kredit Pintar, nasabah wajib memenuhi persyaratan berikut:',
    key1: '1. Tercatat sebagai Warga Negara Indonesia',
    key2: '2. Usia diantara 18-60 tahun',
    key3: '3. Memiliki KTP yang masih berlaku',
    key4: '4. Memiliki akun Bank sesuai dengan data KTP',
    key5: '5. Berdomisili di Indonesia',
    key6: '6. Memenuhi dokumen dan Data lain yang diperlukan',
  },
  en: {
    title: 'Kredit Pintar Borrower Qualifications',
    subTitle:
      'To apply for a cash loan with instant disbursement in Kredit Pintar, the customers must obey the qualifications as below:',
    key1: '1. Indonesia Citizen',
    key2: '2. Age between 18-60 years old',
    key3: '3. Has a valid Indonesian ID Card',
    key4: '4. Bank account that is synchronized with Indonesian ID Card',
    key5: '5. Live in Indonesia',
    key6: '6. Fulfill another necessary data and documents',
  },
})

const OtherBorrowerSection = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const contentList = ['subTitle', 'key1', 'key2', 'key3', 'key4', 'key5', 'key6']
  return (
    <OtherBorrowerSectionStyles>
      {width >= 1000 ? (
        <div className="other-borrower-section-pc">
          <div className="other-borrower-section-title">{t('title')}</div>
          {contentList.map((item: string) => (
            <div className="other-borrower-section-content" key={item}>
              {t(item as any)}
            </div>
          ))}
        </div>
      ) : (
        <div className="other-borrower-section-mobile">
          <div className="other-borrower-section-title">{t('title')}</div>
          {contentList.map((item: string) => (
            <div className="other-borrower-section-content" key={item}>
              {t(item as any)}
            </div>
          ))}
        </div>
      )}
    </OtherBorrowerSectionStyles>
  )
}

export default OtherBorrowerSection

const OtherBorrowerSectionStyles = styled.div`
  @media only screen and (min-width: 1000px) {
    .other-borrower-section-pc {
      margin: 104px auto 0;
      max-width: 1440px;
      padding: 0 150px;
      .other-borrower-section-title {
        text-align: center;
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
        padding-bottom: 48px;
      }
      .other-borrower-section-content {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        margin-bottom: 20px;
      }
    }
  }
  @media only screen and (max-width: 1000px) {
    padding: 0 24px 48px;
    .other-borrower-section-title {
      text-align: center;
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 38px;
    }
    .other-borrower-section-content {
      font-size: 16px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      margin-bottom: 20px;
    }
  }
`
